/**
 * overlayClose(onClose) — props para el <div> de fondo (overlay) de un modal.
 *
 * Un simple onClick={onClose} en el overlay cierra el modal también cuando el
 * usuario empieza el click ADENTRO del modal (p. ej. seleccionando texto de un
 * input) y suelta el mouse afuera — el evento "click" del DOM se dispara sobre
 * el ancestro común de mousedown/mouseup, que termina siendo el overlay, sin
 * que el "stopPropagation" del contenido del modal lo evite.
 *
 * Esto solo cierra si el mousedown Y el click ocurrieron ambos directamente
 * sobre el overlay (nunca sobre el contenido del modal), evitando el cierre
 * accidental por arrastrar una selección de texto hacia afuera.
 */
export function overlayClose(onClose) {
  return {
    onMouseDown: (e) => {
      e.currentTarget.dataset.downOnOverlay = e.target === e.currentTarget ? "1" : "";
    },
    onClick: (e) => {
      if (e.currentTarget.dataset.downOnOverlay === "1" && e.target === e.currentTarget) {
        onClose(e);
      }
    },
  };
}
